import angular from 'angular';

export default angular
  .module('app.directives.character-limit', [])
  .directive('characterLimit', $timeout => ({
    restrict: 'A',
    require: '^ngModel',
    scope: {
      limit: '=characterLimit',
      count: '=?characterCount',
      remaining: '=?characterRemaining',
    },
    link(scope, element, attrs, ngModel) {
      /**
       * Default character limit
       * @type {Integer}
       */
      if (scope.limit == null) {
        scope.limit = 500;
      }

      /**
       * Set the count, remaining and model validity
       */
      let set = function(val) {
        // Update the count / remaining
        if (val == null) {
          val = '';
        }
        scope.count = val.length;
        scope.remaining = scope.limit - scope.count;

        // Set the validity
        return ngModel.$setValidity('charLimit', scope.remaining >= 0);
      };

      /**
       * Handle user input changes
       * @param  {String} val The view value
       */
      ngModel.$parsers.push(function(val) {
        set(val);
        return val;
      });

      /**
       * Handle scope changes
       * @param  {String} val The model value
       */
      ngModel.$formatters.push(function(val) {
        set(val);
        return val;
      });
    },
  }));
